const CLOUD_NAME = process.env.REACT_APP_CLOUD_NAME;

export const getCldImage = (publicId, width = 1000) => {
  return `https://res.cloudinary.com/${CLOUD_NAME}/image/upload/f_auto,q_auto,w_${width}/${publicId}`;
};

export const getBlurImage = (publicId) => {
  return `https://res.cloudinary.com/${CLOUD_NAME}/image/upload/f_auto,q_10,w_50,e_blur:1000/${publicId}`;
};